import React from "react";

import { useTranslate } from "@hooks/useTranslate";

import { Carousel } from "@www/src/static_pages/components/Carousel";

import { Feedback } from "./Feedback";

export const Feedbacks = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Carousel>
      {Array.from({ length: 5 }).map((_, index) => (
        <Feedback
          author={translate(`review_author_${index + 1}`)}
          date={translate(`review_date_${index + 1}`)}
          feedback={translate(`review_feedback_${index + 1}`)}
          title={translate(`review_title_${index + 1}`)}
          key={index}
        />
      ))}
    </Carousel>
  );
};
